import debug from 'debug';
import { createForms } from 'react-redux-form';

import * as views from './views';
import nav from './nav';
import auth from './auth';
import { TEAMS_KEY } from '../actions/teams.types';
import teamsReducer from './teams';
import { SIDEBAR_KEY } from '../actions/sidebar.types';
import sidebarReducer from './sidebar';
import trackingReducer, { STORE_KEY as TRACKING_KEY } from './tracking';
import tableControlsReducer, { STORE_KEY as TABLE_CONTROLS_KEY } from './tableControls';
import formulasReducer, { STORE_KEY as FORMULAS_KEY } from './formula';
import seasonReducer, { STORE_KEY as SEASON_KEY } from './season';
import playerSearchReducer, { STORE_KEY as PLAYER_SEARCH_STORE_KEY } from './playerSearch';
import positionsReducer, { STORE_KEY as POSITIONS_KEY } from '../reducers/positions';
import toolDescriptionsReducer, { STORE_KEY as TOOLDESCRIPTIONS_KEY } from '../reducers/toolDescriptions';
import emailSettingsReducer from './emailSettings';
import { USER_EMAIL_SETTINGS_KEY } from '../actions/emailSettings';
import matchupsReducer, { STORE_KEY as MATCHUPS_KEY } from './matchups';

// View Reducers
import customLeagueReducer, { STORE_KEY as CUSTOM_LEAGUE_KEY } from '../../app/views/Custom/module/custom';
import accountInfoReducer, { STORE_KEY as ACCOUNT_INFO_KEY } from '../../app/views/AccountInfo/module/accountInfo';
import cheatSheetsReducer, { STORE_KEY as CHEAT_SHEETS_KEY } from '../../app/views/CheatSheets/module/cheatSheets';
import dynastyReducer, { STORE_KEY as DYNASTY_KEY } from '../../app/views/Dynasty/module/dynasty';
import auction10Reducer, { STORE_KEY as AUCTION10_KEY } from '../../app/views/Auction10/module/auction10';
import auction12Reducer, { STORE_KEY as AUCTION12_KEY } from '../../app/views/Auction12/module/auction12';
import top200Reducer, { STORE_KEY as TOP200_KEY } from '../../app/views/Top200/module/top200';
import top200PPRReducer, { STORE_KEY as TOP200PPR_KEY } from '../../app/views/Top200PPR/module/top200PPR';
import top200QBReducer, { STORE_KEY as TOP200QB_KEY } from '../../app/views/Top200QB/module/top200QB';
import seasonStatsReducer, { STORE_KEY as SEASON_STATS_KEY } from '../../app/views/Season/module/seasonStats';
import weeklyStatsReducer, { STORE_KEY as WEEKLY_STATS_KEY } from '../../app/views/WeeklyStats/module/weeklyStats';
import huddleSearchReducer, { STORE_KEY as HUDDLE_SEARCH_KEY } from '../../app/views/HuddleSearch/module/huddleSearch';
import projectionsReducer, { STORE_KEY as PROJECTIONS_KEY } from '../../app/views/PlayerProjections/module/projections';
import predictionsReducer, { STORE_KEY as PREDICTIONS_KEY } from '../../app/views/Predictions/module/predictions';
import teamPositionRankingsReducer, { STORE_KEY as TEAM_POSITION_RANKINGS_KEY } from '../../app/views/TeamPositionRankings/module/teamPositionRankings';
import boxScoresReducer, { STORE_KEY as BOX_SCORES_KEY } from '../../app/views/BoxScores/module/boxScores';
import startBenchReducer, { STORE_KEY as START_BENCH_KEY } from '../../app/views/StartBench/module/startBench';
import waiverWireReducer, { STORE_KEY as WAIVER_WIRE_KEY } from '../../app/views/WaiverWire/module/waiverWire';
import playerReducer, { STORE_KEY as PLAYER_KEY } from '../../app/views/Player/module/player';
import teamReducer, { STORE_KEY as TEAM_KEY } from '../../app/views/Team/module/team';
import newsReducer, { STORE_KEY as NEWS_KEY } from '../../app/views/News/module/news';
import depthchartsReducer, { STORE_KEY as DEPTHCHARTS_KEY } from '../../app/views/DepthCharts/module/depthcharts';
import strengthOfScheduleReducer, { STORE_KEY as SOS_KEY } from '../../app/views/StrengthOfSchedule/module/strengthOfSchedule';
import teamRanksMatchupsReducer, { STORE_KEY as TEAM_PRM_KEY } from '../../app/views/TeamPositionRanksMatchups/module/teamPRM';
import paymentInformationReducer, { STORE_KEY as PAYMENT_INFORMATION_KEY } from './paymentInformation';
import gameStatsMatchupsReducer, { STORE_KEY as GAME_STATS_MATCHUPS_KEY } from '../../app/views/GameStatsMatchups/module/gameStatsMatchups';
import matchupAnalysisReducer, { STORE_KEY as MATCHUPS_ANALYSIS_KEY } from '../../app/views/Predictions/MatchupAnalysis/module/analysis';
import requestPasswordReducer, { STORE_KEY as REQUEST_PASSWORD_KEY } from '../../app/views/PasswordRequest/module/requestPassword';
import requestPassword2Reducer, { STORE_KEY as REQUEST_PASSWORD2_KEY } from '../../app/views/PasswordForceRequest/module/requestPassword2';
import resetPasswordReducer, { STORE_KEY as RESET_PASSWORD_KEY } from '../../app/views/PasswordReset/module/resetPassword';
import requestUsernameReducer, { STORE_KEY as REQUEST_USERNAME_KEY } from '../../app/views/UsernameRequest/module/requestUsername';
import printReducer, { STORE_KEY as PRINT_KEY } from '../../app/views/Print/module/print';
import printProjectionsReducer, { STORE_KEY as PRINT_PROJECTIONS_KEY } from '../../app/views/PrintProjections/module/printprojections';
import nflScheduleReducer, { STORE_KEY as NFL_SCHEDULE_KEY } from '../../app/views/NFLSchedule/module/nflSchedule';

const log = debug('huddle:store:reducers:');

const reducers = {
  ...views,
  nav,
  ...createForms({ auth }),
  [TRACKING_KEY]: trackingReducer,
  [TABLE_CONTROLS_KEY]: tableControlsReducer,
  [TEAMS_KEY]: teamsReducer,
  [SIDEBAR_KEY]: sidebarReducer,
  [FORMULAS_KEY]: formulasReducer,
  [SEASON_KEY]: seasonReducer,
  [POSITIONS_KEY]: positionsReducer,
  [TOOLDESCRIPTIONS_KEY]: toolDescriptionsReducer,
  [PLAYER_SEARCH_STORE_KEY]: playerSearchReducer,
  [MATCHUPS_KEY]: matchupsReducer,

  // View reducers
  [CUSTOM_LEAGUE_KEY]: customLeagueReducer,
  [ACCOUNT_INFO_KEY]: accountInfoReducer,
  [HUDDLE_SEARCH_KEY]: huddleSearchReducer,
  [CHEAT_SHEETS_KEY]: cheatSheetsReducer,
  [DYNASTY_KEY]: dynastyReducer,
  [AUCTION10_KEY]: auction10Reducer,
  [AUCTION12_KEY]: auction12Reducer,
  [TOP200_KEY]: top200Reducer,
  [TOP200PPR_KEY]: top200PPRReducer,
  [TOP200QB_KEY]: top200QBReducer,
  [SEASON_STATS_KEY]: seasonStatsReducer,
  [WEEKLY_STATS_KEY]: weeklyStatsReducer,
  [USER_EMAIL_SETTINGS_KEY]: emailSettingsReducer,
  [PROJECTIONS_KEY]: projectionsReducer,
  [PREDICTIONS_KEY]: predictionsReducer,
  [MATCHUPS_ANALYSIS_KEY]: matchupAnalysisReducer,
  [TEAM_POSITION_RANKINGS_KEY]: teamPositionRankingsReducer,
  [BOX_SCORES_KEY]: boxScoresReducer,
  [START_BENCH_KEY]: startBenchReducer,
  [WAIVER_WIRE_KEY]: waiverWireReducer,
  [PLAYER_SEARCH_STORE_KEY]: playerSearchReducer,
  [PLAYER_KEY]: playerReducer,
  [TEAM_KEY]: teamReducer,
  [NEWS_KEY]: newsReducer,
  [DEPTHCHARTS_KEY]: depthchartsReducer,
  [SOS_KEY]: strengthOfScheduleReducer,
  [TEAM_PRM_KEY]: teamRanksMatchupsReducer,
  [PAYMENT_INFORMATION_KEY]: paymentInformationReducer,
  [GAME_STATS_MATCHUPS_KEY]: gameStatsMatchupsReducer,
  [REQUEST_PASSWORD_KEY]: requestPasswordReducer,
  [REQUEST_PASSWORD2_KEY]: requestPassword2Reducer,
  [RESET_PASSWORD_KEY]: resetPasswordReducer,
  [REQUEST_USERNAME_KEY]: requestUsernameReducer,
  [PRINT_KEY]: printReducer,
  [PRINT_PROJECTIONS_KEY]: printProjectionsReducer,
  [NFL_SCHEDULE_KEY]: nflScheduleReducer,
};
log({ reducers });

export default reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js